import { OmitDeep } from 'type-fest';

import { Slide, StylesConfig as PlayerStylesConfig } from '@player/content';

import type { TextBlock } from '@/entities/content/api/types';

enum TextPosition {
  Bottom = 'bottom',
  Center = 'center',
}

export const contentStylesDefaults: OmitDeep<PlayerStylesConfig, 'logo.src'> & {
  // TODO: update player/loader to use mediaContentOrigin + path instead
  logo: { file_path: string };
} = {
  colors: {
    primary: '#0693E3',
    secondary: '#FFFFFF',
  },
  controls: {
    enabled: true,
    play_button: true,
    progress_bar: true,
    fullscreen_button: true,
    mute_button: true,
    navigation_buttons: true,
  },
  link_button: {
    enabled: true,
    color: '#FFFFFF',
    bg_color: '#0693E3',
    text: 'Read more',
  },
  text: {
    font: 'Arial',
    color: '#FFFFFF',
    font_size: 18,
    bold: true,
    italic: false,
    position: TextPosition.Bottom,
  },
  logo: {
    enabled: false,
    over_video: true,
    size: 50,
    opacity: 25,
    position: 'top-right',
    file_path: '',
  },
  text_blocks_animation: {
    style: 'horizontal',
  },
  slides_animation: {
    style: 'fade-in',
    duration: 5,
  },
};

// export const contentStylesDefaults: DefaultValues<ContentStyles> = {
//   type: 'video',
//   config: contentStylesDefaults,
// };

export const defaultTextBlocks: TextBlock[] = [
  {
    start: 0,
    end: 10,
    content: `
  This overlay shows article headlines with links and a Read more button. 
  It’s used to highlight featured posts or recent updates directly on the video. 
  Viewers can see the title, get a quick idea of the content, and click through to read the full article.
  `,
    url: 'https://google.com/',
  },
  {
    start: 10,
    end: 20,
    content: `
 Lorem ipsum dolor sit amet, consectetur adipiscing elit. Sed do eiusmod tempor incididunt ut labore et dolore magna aliqua.
  `,
    url: 'https://google.com/',
  },
  {
    start: 20,
    end: 100,
    content: `
Lorem ipsum dolor sit amet, consectetur adipiscing elit. Sed do eiusmod tempor incididunt ut labore et dolore magna aliqua.
  `,
    url: 'https://google.com/',
  },
];

export const defaultSlides: Slide[] = [
  {
    image: '/slides/slide_01.jpg',
    // image: 'https://picsum.photos/seed/slide1/560/316',
    title: 'Breaking: New Technology Revolutionizes Industry',
    link: 'https://example.com/article-1',
  },
  {
    // image: 'https://picsum.photos/seed/slide2/560/316',
    image: '/slides/slide_02.jpg',
    title: 'Scientists Discover New Species in Deep Ocean',
    link: 'https://example.com/article-2',
  },
  {
    // image: 'https://picsum.photos/seed/slide3/560/316',
    image: '/slides/slide_03.jpg',
    title: 'Global Markets React to Economic Changes',
    link: 'https://example.com/article-3',
  },
];
